import { computed, defineAsyncComponent } from "vue";
import { useSiteTemplate } from "@/composables/useSiteTemplate";

export function useTemplateSection(sectionKey) {
  const siteTemplate = useSiteTemplate();

  const sectionConfig = computed(() => siteTemplate.resolveSection(sectionKey) || {});
  const component = computed(() => {
    const config = sectionConfig.value;
    if (typeof config.component !== "function") {
      return null;
    }
    return defineAsyncComponent(config.component);
  });
  const hasSectionTemplate = computed(() => Boolean(component.value));

  return {
    ...siteTemplate,
    sectionConfig,
    component,
    hasSectionTemplate,
  };
}

export default useTemplateSection;
